<template>
  <div class="chat">
    <v-container class="pt-0">
      <v-row>
        <chat-history
            :conversation="conversation"
            :loading="chatLoading"
            v-on:autoScrollLockChanged="onAutoScollLockChanged"
            :scrollToEndTrigger="chatScrollToEndTrigger"
            :height="height"
        />
      </v-row>
    </v-container>
    <v-form lazy-validation @submit="send">
      <v-container class="pt-0">
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-text-field
              class="textInputField"
              v-model="message"
              :disabled="false"
              autocomplete="off"
              clearable
              :label="$t('chat.message')"
              :prepend-icon="this.autoScrollLock ? 'mdi-arrow-down-circle' : undefined"
              @click:prepend="scrollChatHistoryToEnd()"
              :append-outer-icon="'mdi-send'"
              @click:append-outer="send"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import ChatHistory from "@/widgets/ChatHistory";
import eventBus, {EVENT_GAMEINSTANCE_UPDATED} from "@/plugins/eventbus";

export default {
  name: "Chat",
  components: {
    ChatHistory
  },
  props: {
    game: {
      type: Object,
      required: false
    },
    height: {
      default: null
    },
    otherChannelName: {
      type: String,
      required: false,
    },
    active: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      tmpLastReceivedMessage: undefined,
      conversation: undefined,
      message: undefined,
      chatScrollToEndTrigger: undefined,
      autoScrollLock: false,
      chatLoading: false,
      messageReadTimer: undefined,
      markMessageIdAsRead: undefined,
      loading: false
    };
  },
  computed: {
    channelName: function() {
      return this.otherChannelName ?? this.game?.chatUid;
    }
  },
  watch: {
    active: function(val) {
      if (val == true) {
        console.log('User switched to chat history.')
        this.loadChatConversation()
      }
    }
  },
  mounted() {
    if (!this.$realtime.echo) {
      console.log("WARN: Echo is not available?!");
    }
    this.loadChatConversation();
    if (this.$realtime.echo) {
      this.$realtime.echo.private(this.channelName).listen("NewMessage", e => {
        this.onNewMessage(e);
      });
    } else {
      console.log('WARN: Echo is not available for chat')
    }
  },
  created() {},
  beforeDestroy() {
    if (this.active) {
      // Leaving an active (visible) chat, reset badge to 0 to ensure there is no new message
      console.log('Resetting chat badge')
      this.game.yourUnreadChatMessages = 0;
      eventBus.$emit(EVENT_GAMEINSTANCE_UPDATED, this.game);
    }
    if (this.$realtime.echo) {
      this.$realtime.echo.leave(this.channelName);
    }
  },
  methods: {
    loadChatConversation() {
      this.loading = true;
      this.chatLoading = true;
      // console.log("Loading chat conversations");
      this.$api
        .getChatConversations(this.channelName)
        .then(response => {
          this.loading = false;
          this.chatLoading = false;
          this.conversation = response.data;
          this.game.yourUnreadChatMessages = 0;
          eventBus.$emit(EVENT_GAMEINSTANCE_UPDATED, this.game);
        })
        .catch(error => {
          this.loading = false;
          this.chatLoading = false;
          this.$common.onError(error)
        });
      return false;
    },
    onNewMessage(msg) {
      // console.log("Received new chat message", msg);
      this.tmpLastReceivedMessage = msg;
      if (this.conversation) {
        this.conversation.unshift(msg.message);
        // console.log('active', this.active)
        if (!this.active) {
          this.game.yourUnreadChatMessages = this.game.yourUnreadChatMessages ? this.game.yourUnreadChatMessages + 1 : 1;
          eventBus.$emit(EVENT_GAMEINSTANCE_UPDATED, this.game);
        }
        if (this.active) {
          if (msg.player.uid != this.$store.state.profile.uid) {
            this.onMessageRead(msg.message.id)
          } else {
            // console.log('Ignoring own message to be marked as read')
          }
        }
      } else {
        // Chat history not loaded yet, but message received
        this.loadChatConversation();
      }
    },
    onAutoScollLockChanged(e) {
      // console.log('onAutoScollLockChanged', e)
      this.autoScrollLock = e.autoScrollLock;
    },
    scrollChatHistoryToEnd() {
      this.chatScrollToEndTrigger = {}
    },
    onMessageRead(id) {
      // console.log('onMessageRead', id)
      // Mark message as read at most every second, but at least every second.
      this.markMessageIdAsRead = id;
      if (!this.messageReadTimer) {
        this.messageReadTimer = setTimeout(() => {
          this.messageReadTimer = undefined;
          this.markMessageAsRead(this.markMessageIdAsRead)
          this.markMessageIdAsRead = undefined;
        }, 3000)
      }
    },
    markMessageAsRead(id) {
      let data = {id: id, groupName: this.channelName};
      // console.log('markMessageAsRead', id, data)
      this.$realtime.whisperInUserChannel('user-message-read', data)
    },
    send(e) {
      if (!this.message) return;

      e.preventDefault();
      this.loading = true;
      // console.log("Sending message");
      let messageInput = this.message;
      this.message = null;
      this.$api
        .sendChatMessage(this.channelName, messageInput)
        .then(() => {
          this.loading = false;
          this.scrollChatHistoryToEnd()
        })
        .catch(error => {
          this.message = messageInput;
          this.loading = false;
          this.$common.onError(error)
        });
      return false;
    },
  }
};
</script>

<style scoped>
.textInputField >>> .v-input__icon--prepend .v-icon {
    color: var(--v-accent-base) !important;
}
</style>


